import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ApiService from '../../../../domain/services/ApiService';

export const DifficultyFilter = props => {
  const [statuses, setStatuses] = useState([]);


  useEffect(() => {
    const loadDiffs = async () => {
      const diffs = await ApiService.get("categorization/summary/difficulties");
      setStatuses(diffs.map(x => ({
        id: x,
        label: x + ""
      })));
    }

    loadDiffs();
  }, [])


  return (
    <Autocomplete
      options={statuses}
      getOptionLabel={(option) => option.label}
      onChange={(event, value) => props.onChange(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Difficulty"
          variant="outlined"
          size="small"
          style={{minWidth: 200}}
        />
      )}
    />
  )
}

export default DifficultyFilter;
